"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getKeys = function (keys) {
    if (keys == null) {
        return [];
    }
    if (!Array.isArray(keys)) {
        return [keys];
    }
    return keys;
};
exports.default = getKeys;
